function TransactionsTable({ data }) {
  return (
    <div className="mt-6 bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
      
      {/* HEADER */}
      <div className="flex justify-between mb-4">
        <h2 className="text-lg font-semibold">Recent Transactions</h2>
        <span className="text-sm text-blue-600 cursor-pointer">
          View All
        </span>
      </div>

      {/* TABLE HEADER */}
      <div className="grid grid-cols-4 text-xs text-gray-400 uppercase mb-2">
        <span>Description</span>
        <span>Type</span>
        <span>Amount</span>
        <span className="text-right">Date</span>
      </div>

      {/* ROWS */}
      {data.map((item, i) => (
        <div
          key={i}
          className="grid grid-cols-4 items-center text-sm py-2 border-b last:border-0 hover:bg-gray-50 transition"
        >
          
          {/* DESCRIPTION */}
          <span className="text-gray-700">
            {item.description || item.project || "Txn"}
          </span>

          {/* TYPE */}
          <span
            className={`text-xs px-2 py-1 rounded w-fit ${
              item.type === "income"
                ? "bg-green-100 text-green-600"
                : "bg-red-100 text-red-500"
            }`}
          >
            {item.type === "income" ? "Income" : "Expense"}
          </span>

          {/* AMOUNT */}
          <span className="font-medium">
            ₹{(item.amount || 0).toLocaleString()}
          </span>

          {/* DATE */}
          <span className="text-right text-gray-500">
            {item.date || "-"}
          </span>
        </div>
      ))}
    </div>
  );
}

export default TransactionsTable;